export default {
    deviceProxy: process.env.REACT_APP_LARVA_DEVICE_PROXY,
    deviceTimeout: Number(process.env.REACT_APP_LARVA_DEVICE_TIMEOUT) || 1000,
    videoProxy: process.env.REACT_APP_LARVA_VIDEO_PROXY,
    mantisUrl: process.env.REACT_APP_LARVA_MANTIS_URL,
    timeout: Number(process.env.REACT_APP_LARVA_TIMEOUT) || 1000,
    wsClientTimeOut: Number(process.env.REACT_APP_LARVA_WS_CLIENT_TIMEOUT) || 30000,
} as const;
